import { Tooltip } from '@civilgrid/ui/components';
import type { VisibilityState } from '@tanstack/react-table';
import type { GeoJsonProperties } from 'geojson';
import type { ExportableColumnDef } from '~/components2/Table';

export const columns: ExportableColumnDef<GeoJsonProperties>[] = [
  {
    id: 'id',
    header: 'ID',
    accessorFn: (p) => p?.id ?? '',
  },
  {
    id: 'companyName',
    header: 'Company Name',
    accessorFn: (p) => p?.company_name || p?.report_extra?.company_name || p?.report_extra?.company || p?.id || '',
  },
  {
    id: 'mapKey',
    header: 'Map Key',
    accessorFn: (p) => p?.map_key_loc ?? '',
    sortingFn: (rowA, rowB, columnId) => {
      const a = rowA.getValue(columnId);
      const b = rowB.getValue(columnId);
      const isA_NA = a === 'N/A' || a === '' || a == null;
      const isB_NA = b === 'N/A' || b === '' || b == null;
      if (isA_NA && isB_NA) return 0;
      if (isA_NA) return 1;
      if (isB_NA) return -1;
      return Number(a) - Number(b);
    },
  },
  {
    id: 'address',
    header: 'Address',
    accessorFn: (p) => p?.address?.address ?? '',
  },
  {
    id: 'city',
    header: 'City',
    accessorFn: (p) => p?.address?.city ?? '',
  },
  {
    id: 'source',
    header: 'Source',
    accessorFn: (p) => p?.source_name ?? '',
    cell: (cell) => {
      const sourceName = cell.getValue() as string;
      const sourceDesc = cell.row.original?.source_desc;

      if (sourceDesc) {
        return (
          <Tooltip
            text={sourceDesc}
            aria-label={sourceName || 'Source details'}
            triggerClassName="cursor-help"
            data-testid={`environmental-study-source-${cell.row.id}`}
          >
            {sourceName || <>&nbsp;</>}
          </Tooltip>
        );
      }

      return sourceName || <>&nbsp;</>;
    },
  },
  {
    id: 'distance',
    header: 'Distance (ft)',
    accessorFn: (p) => {
      const distance = p?.distance;
      return distance ? Math.round(Number(distance)) : '';
    },
  },
  {
    id: 'elevation',
    header: 'Elevation (ft)',
    accessorFn: (p) => {
      const elevation = p?.elev_feet;
      return elevation ? Math.round(Number(elevation)) : '';
    },
  },
  {
    id: 'x',
    header: 'X Coordinate',
    accessorFn: (p) => p?.x ?? '',
  },
  {
    id: 'y',
    header: 'Y Coordinate',
    accessorFn: (p) => p?.y ?? '',
  },
];

export const columnVisibility: VisibilityState = {
  id: false,
  x: false,
  y: false,
};
